import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawErrorIcon from "./RawErrorIcon.svg.jsx";

const ErrorIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawErrorIcon} {...props} />;
});

export default ErrorIcon;
